/**
 * Выбор провайдера эквайринга на сайте.
 *
 * Дефолт — 'tinkoff' (Т-Касса, боевой терминал): основной способ оплаты сайта.
 * ЮKassa остаётся запасным путём и включается точечно, без релиза:
 *   - разово через URL: ?provider=yookassa (запоминается в localStorage);
 *   - вернуться на Т-Кассу: ?provider=tinkoff.
 *
 * Мобильное приложение сюда не смотрит — оно ходит в ЮKassa напрямую.
 */
export type PaymentProvider = 'yookassa' | 'tinkoff';

const STORAGE_KEY = 'payment_provider';

const DEFAULT_PROVIDER: PaymentProvider = 'tinkoff';

export function getPaymentProvider(): PaymentProvider {
  try {
    const params = new URLSearchParams(window.location.search);
    const fromUrl = params.get('provider');
    if (fromUrl === 'tinkoff' || fromUrl === 'yookassa') {
      window.localStorage.setItem(STORAGE_KEY, fromUrl);
      return fromUrl;
    }
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === 'tinkoff' || stored === 'yookassa') {
      return stored;
    }
  } catch {
    // localStorage/URL недоступны — молча уходим в дефолт
  }
  return DEFAULT_PROVIDER;
}

export function isTinkoffProvider(): boolean {
  return getPaymentProvider() === 'tinkoff';
}
